import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';
import { chartjs } from './helpers';
import theme from './theme';
import './assets/css/index.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import validators from './common/validators';
import Routes from './Routes';
import Notification from './components/Notification';
import Loading from 'components/Loading';

Chart.defaults.global.defaultFontFamily = 'IRANSans';
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

export default () => {
  return (
    <ThemeProvider theme={theme}>
      <Notification />
      <BrowserRouter basename="/">
        <Suspense fallback={<Loading />}>
          <Routes />
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
};
